import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee30362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "saveNewCard" }
const _hoisted_2 = { class: "stripeForm" }
const _hoisted_3 = { class: "form-group intestatario" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Intestatario", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Numero", -1))
const _hoisted_7 = {
  id: "card-number",
  class: "field empty",
  ref: "cardNumberRef"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-8" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Scadenza", -1))
const _hoisted_12 = {
  id: "card-expiry",
  class: "field empty",
  ref: "card-expiry-ref"
}
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "CVC", -1))
const _hoisted_16 = {
  id: "card-cvc",
  class: "field empty third-width",
  ref: "card-cvc-ref"
}
const _hoisted_17 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-conrol",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cardholderName) = $event))
        }, null, 512), [
          [_vModelText, _ctx.cardholderName]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, null, 512)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, null, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, null, 512)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "genericButton btn-linear-blue mt-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addCard())),
        disabled: _ctx.addButtonDisabled
      }, " Aggiungi carta ", 8, _hoisted_18)
    ])
  ]))
}